import React, { PureComponent, Fragment } from 'react';
import { withNamespaces } from 'react-i18next';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import DialogForm from './../../Global/Modals/DialogForm';
import Button from '@material-ui/core/Button';
import ButtonStyles from '../../../styles/button';
import CommentSubscribedButton from './CommentSubscribedButton';
import CommentInput from './CommentInput';
import CommentList from './CommentList';

const styles = () => ({
  dialogContent: {
    padding: 0
  },
  title: {
    borderBottom: '1px solid #E6E8E9'
  }
});
export class AllCommentsModal extends PureComponent {
  static propTypes = {
    comments: PropTypes.array.isRequired,
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    onCreate: PropTypes.func.isRequired,
    onDelete: PropTypes.func.isRequired,
    users: PropTypes.array.isRequired,
    toggleSubscribe: PropTypes.func.isRequired,
    subscribed: PropTypes.bool.isRequired,
    onEditClick: PropTypes.func.isRequired
  };
  state = {
    comments: this.props.comments
  };
  componentDidUpdate(prevProps) {
    const { comments } = this.props;
    if (prevProps.comments !== comments) {
      this.setState({ comments: comments });
    }
  }

  render() {
    const {
      classes,
      t,
      open,
      onClose,
      onCreate,
      onDelete,
      users,
      toggleSubscribe,
      subscribed,
      onEditClick
    } = this.props;
    const { comments } = this.state;
    return (
      <DialogForm
        open={open}
        onClose={onClose}
        title={t('Shipment Comments')}
        classes={{
          dialogBase: classes.dialogContent,
          titleCustom: classes.title
        }}
        footer={
          <Fragment>
            <Button
              className={classes.button}
              onClick={onClose}
              color={'primary'}
              classes={{ label: classes.buttonLabel }}
            >
              {t('Ok')}
            </Button>
          </Fragment>
        }
        secondaryAction={
          <CommentSubscribedButton
            subscribed={subscribed}
            onClick={toggleSubscribe}
          />
        }
      >
        <CommentInput onSave={onCreate} users={users} />
        <CommentList
          comments={comments}
          users={users}
          onDelete={onDelete}
          onEditClick={editCommentObject => {
            onClose();
            onEditClick(editCommentObject);
          }}
        />
      </DialogForm>
    );
  }
}
const translatedAllCommentsModal = withNamespaces()(AllCommentsModal);
export default withStyles(styles, ButtonStyles)(translatedAllCommentsModal);
